module.exports = __webpack_public_path__ + "img/text-align-center.fb11da29.svg";